import { GameVars } from "./GameVars";
import { Howl } from "howler";
import { GameManager } from "./GameManager";

// audiosprite -e "mp3,ogg" -o ../assets/audio/audiosprite *.mp3 -f howler -b 96

export class AudioManager {

    public static howl: Howl = null;

    private static loopVolume: number;
    private static loopKey: string;
    private static lastEffectPlayed: string;
    private static loopID: number; 
    private static timeLastEffectPlayed: number;

    public static init(): void {

        AudioManager.lastEffectPlayed = null;
        AudioManager.loopID = null;
        AudioManager.loopKey = null;
    }

    public static toggleAudioState(isSoundTrack: boolean): void {

        if (isSoundTrack) {

            GameVars.gameData.muted = !GameVars.gameData.muted;

            if (GameVars.gameData.muted) {
                AudioManager.stopLoop();
            } else {
                AudioManager.resumeLoop();
            }

        } else {

            GameVars.gameData.data.fxMuted = !GameVars.gameData.data.fxMuted;
        }

        GameManager.writeGameData();
    }

    public static mute(): void {

        if (AudioManager.howl === null) {
            return;
        }

        AudioManager.howl.mute(true);
    }

    public static unmute(): void {

        if (AudioManager.howl === null) {
            return;
        }

        AudioManager.howl.mute(false);
    }

    public static playSound(key: string, loop?: boolean, volume?: number, rate?: number, seek?: number): number {

        if (loop && GameVars.gameData.muted || !loop && GameVars.gameData.data.fxMuted) {
            return;
        }
        
        const t = new Date().getTime();

        if (t - AudioManager.timeLastEffectPlayed < 60 && AudioManager.lastEffectPlayed === key) {
            return;
        }

        AudioManager.timeLastEffectPlayed = t;
        AudioManager.lastEffectPlayed = key;

        if (loop && AudioManager.loopKey === key) {
            return;
        }

        loop = loop || false;
        volume = volume || 1;

        const id = AudioManager.howl.play(key);

        AudioManager.howl.volume(volume, id);
          
        if (loop) {

            AudioManager.loopKey = key;

            if (AudioManager.loopID) {
                AudioManager.howl.stop(AudioManager.loopID);
            }

            AudioManager.loopID = id;
            AudioManager.howl.loop(true, AudioManager.loopID);
        }

        if (rate) {
            AudioManager.howl.rate(rate, id);
        }

        if (seek) {
            AudioManager.howl.seek(seek, id);
        }

        return id;
    }

    public static stopSound(id: number): void {

        AudioManager.howl.stop(id);
    }

    public static setLoopVolume(v1: number, v2: number): void {

        if ( GameVars.gameData.muted) {
            return;
        }

        AudioManager.loopVolume = v2;
        
        AudioManager.howl.fade(v1, v2, 500, AudioManager.loopID);
    }

    public static stopLoop(loopID?: number): void {

        let id = AudioManager.loopID || loopID;

        if (id) {
            AudioManager.howl.fade(1, 0, 1000, id);
        }
    }

    public static resumeLoop(loopID?: number): void {

        let id = AudioManager.loopID || loopID;

        if (id) {
            AudioManager.howl.fade(0, AudioManager.loopVolume, 1000, id);
        } else {
            AudioManager.loopKey = "soundtrack_mahjong";
            AudioManager.loopID = AudioManager.howl.play(AudioManager.loopKey);
            AudioManager.howl.loop(true, AudioManager.loopID);
        }
    }

    public static onBlur(): void {
        
        if (!GameVars.gameData.muted && AudioManager.howl) {
            AudioManager.howl.mute(true);
        }
    }

    public static onFocus(): void {
        
        if (!GameVars.gameData.muted && AudioManager.howl) {
            AudioManager.howl.mute(false);
        }
    }
}
